// src/screens/KioskHomeScreen.js
import React, { useContext, useEffect } from 'react';
import { AuthContext } from '../context/AuthContext';
import { useNavigate } from 'react-router-dom';
import { useKioskDraft } from '../context/KioskDraftContext';
import AppHeader from '../components/AppHeader';

const KioskHomeScreen = () => {
  const { user } = useContext(AuthContext);
  const navigate = useNavigate();
  const { clearDraft } = useKioskDraft();

  // Back at the start: forget any unfinished walk-in.
  useEffect(() => { clearDraft(); }, [clearDraft]);

  useEffect(() => {
    if (!user) {
      navigate('/login');
      return;
    }
    if (user.role !== 'kiosk') {
      navigate('/');
      return;
    }
  }, [user, navigate]);

  return (
    <div className="flex flex-col h-full max-w-3xl mx-auto w-full">
      <AppHeader />

      <div className="flex-1 flex flex-col items-center justify-center p-6">
        <div className="text-center space-y-6 max-w-md">
          <div className="space-y-2">
            <h1 className="text-3xl font-bold">Welcome to</h1>
            <h2 className="text-2xl font-semibold text-app-accent">
              {user?.dealer?.name || 'Dealership'} Kiosk
            </h2>
          </div>

          <p className="text-app-text-secondary-light dark:text-app-text-secondary text-sm">
            Here for a test drive? Check in with your QR code. Or book a new appointment.
          </p>

          <div className="space-y-3 w-full">
            <button
              onClick={() => navigate('/kiosk/checkin')}
              className="w-full py-5 rounded-2xl bg-app-accent text-black text-lg font-bold hover:opacity-90 transition-opacity"
            >
              Check In
            </button>

            <button
              onClick={() => navigate('/kiosk/book')}
              className="w-full py-4 rounded-2xl bg-app-bg-secondary-light dark:bg-app-bg-secondary text-app-text-light dark:text-app-text text-base font-semibold hover:opacity-90 transition-opacity"
            >
              Create New Appointment
            </button>

            <button
              onClick={() => navigate('/kiosk/search')}
              className="w-full py-4 rounded-2xl bg-app-bg-secondary-light dark:bg-app-bg-secondary text-app-text-light dark:text-app-text text-base font-semibold hover:opacity-90 transition-opacity"
            >
              Find Appointment
            </button>
          </div>

          <div className="pt-4 text-xs text-app-text-secondary-light dark:text-app-text-secondary">
            Kiosk ID: <span className="font-mono">{user?.kioskId || 'N/A'}</span>
          </div>
        </div>
      </div>
    </div>
  );
};

export default KioskHomeScreen;
